<template>
  <div class="user-center__product-edit-container user-center__common-child-container --for-edit">
    <div class="product-edit__wrapper center-common-form-wrapper">
      <!-- 顶部 -->
      <sub-page-header>
        <template #title>
          <router-link tag="div" :to="nav.url" active-class="active" class="title__front-item"
            v-for="(nav, index) in breadcrumbs" :key="index">{{ nav.name }}</router-link>
        </template>
        <template #hint>
          <p>
            为保证上架速度，请保证设计包完整度及真实性，带有<i class="circle"></i>的项目是必填的项目
          </p>
        </template>
      </sub-page-header>
      <!-- form部分 -->
      <user-form v-if="isNew || (!isNew && !editLoading)" :form="form" :rules="rules" :render="renderItems" ref="postForm"
        @formValidated="onSubmit" @formValidateError="onFormValidateError" :divider="dividerConfig">
        <template #hint>
          <div class="form-hint__text">
            <p>
              注：请如实填写产品及供应商信息，对于虚假和不符合规定的信息后台有权不予通过。通过审核会在前端发布显示。
            </p>
          </div>
        </template>
        <template #bts>
          <el-button v-for="(bt, btindex) in renderBts" class="bt__item" :key="btindex"
            :class="[bt.type === 'submit' ? 'bt__submit' : 'bt__cancel', bt.classes]" :data-index="btindex"
            :loading="Number(btCurrentIndex) === Number(btindex) && loading"
            :disabled="Number(btCurrentIndex) !== Number(btindex) && loading"
            @click="bt.onClick && bt.onClick(bt.extendParams, $event)">{{ bt.type === 'submit' ? (isNew ? bt.label :
              bt.editLabel) : bt.label }}</el-button>
        </template>
      </user-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { molds } from '@/api/common';
import { create, editDetail, edit } from '@/api/product';
import { parseImage } from '@/filters';
import SubPageHeader from '../_pageHeader.vue';
import UserForm from '../_form.vue';
import localstorage from "@/assets/utils/localstorage";

export default {
  props: {
    id: undefined,
  },
  components: {
    SubPageHeader,
    UserForm,
  },
  data() {
    return {
      editLoading: false,
      loading: false,
      btCurrentIndex: -1,
      breadcrumbs: [
        {
          name: '发布产品',
          url: '/my/product/create/',
        },
      ],
      form: {
        title_picture_id: [],
        picture_ids: [],
        name: '',
        mold_id: '',
        mold_ids: [],
        prov_id: '',
        content: '',
        place: '',
        tags: '',
        model: '',
        style: '',
        absorption: '',
        size: '',
        brand: '',
        min_price: '',
        max_price: '',
        su_desc: [],
        install_desc: [],
        effect_tagsList: [],
      },
      rules: {
        title_picture_id: [
          {
            required: true,
            message: '请上传封面',
            trigger: 'change',
          },
        ],
        picture_ids: [
          {
            required: true,
            message: '请上传产品图片',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请填写产品名称',
            trigger: 'blur',
          },
        ],
        mold_id: [
          {
            required: true,
            message: '请选择产品分类',
            trigger: 'change',
          },
        ],
        mold_ids: [
          {
            required: true,
            message: '请选择产品子分类',
            trigger: 'change',
          },
        ],
        prov_id: [
          {
            required: true,
            message: '请选择具体城市',
            trigger: 'change',
          },
        ],
        content: [
          {
            required: true,
            message: '请填写产品描述',
            trigger: 'change',
          },
        ],
        place: [
          {
            required: true,
            message: '请填写产品产地',
            trigger: 'blur',
          },
        ],
        model: [
          {
            required: true,
            message: '请填写产品型号',
            trigger: 'blur',
          },
        ],
        style: [
          {
            required: true,
            message: '请填写产品风格',
            trigger: 'blur',
          },
        ],
        absorption: [
          {
            required: true,
            message: '请填写产品吸水率',
            trigger: 'blur',
          },
        ],
        size: [
          {
            required: true,
            message: '请填写产品尺寸',
            trigger: 'blur',
          },
        ],
        brand: [
          {
            required: true,
            message: '请填写产品品牌',
            trigger: 'blur',
          },
        ],
        min_price: [
          {
            required: true,
            message: '请填写产品的最低价格',
            trigger: 'blur',
          },
        ],
        max_price: [
          {
            required: true,
            message: '请填写产品的最高价格',
            trigger: 'blur',
          },
        ],
      },
      renderItems: {
        title_picture_id: {
          fileList: [],
          type: 'img',
          title: '上传封面',
          hint: '支持上传jpg/png/gif格式。',
          limit: 1,
        },
        picture_ids: {
          fileList: [],
          type: 'img',
          title: '上传产品图片',
          hint: '支持上传jpg/png/gif格式，不超过10M，最多6张',
          limit: 6,
        },
        name: {
          type: 'text',
          title: '产品名称',
          hint: '您的名称您做主',
          length: 'long',
        },
        tags: {
          type: 'text',
          title: '关键字',
          hint: '词与词之间用、隔开',
          length: 'long',
        },
        mold_id: {
          type: 'select',
          placeholder: '请选择分类',
          title: '产品分类',
          hint: '请选择您对该产品的分类',
          options: [],
          onChange: this.moldOnChange,
        },
        mold_ids: {
          type: 'checkbox',
          title: '产品子分类',
          hint: '请选择您对该产品的子分类',
          options: [],
          loading: false,
        },
        prov_id: {
          type: 'select',
          placeholder: '请选择所在城市',
          title: '城市',
          hint: '请选择您的产品所在城市',
          options: [],
          onChange: false,
        },
        content: {
          type: 'rich-textarea',
          title: '产品描述',
          hint: '填写描述，有利于更好的了解您的需求',
        },
        place: {
          type: 'text',
          title: '产地',
          hint: '请填写产品产地',
          length: 'medium',
        },
        model: {
          type: 'text',
          title: '型号',
          hint: '请填写产品型号',
          length: 'medium',
        },
        style: {
          type: 'text',
          title: '风格',
          hint: '请填写产品风格',
          length: 'medium',
        },
        absorption: {
          type: 'text',
          title: '吸水率（%）',
          hint: '请填写产品吸水率',
          length: 'medium',
        },
        size: {
          type: 'text',
          title: '尺寸',
          hint: '请填写产品尺寸',
          length: 'medium',
        },
        brand: {
          type: 'text',
          title: '品牌',
          hint: '请填写产品品牌',
          length: 'medium',
        },
        min_price: {
          type: 'text',
          title: '最低价格',
          hint: '请填写产品的最低价格',
          length: 'medium',
        },
        max_price: {
          type: 'text',
          title: '最高价格',
          hint: '请填写产品的最高价格',
          length: 'medium',
        },
        is_customized: {
          type: 'radio',
          title: '是否可定制效果',
          hint: '请填写产品是否可定制效果',
          options: [
            { id: 1, name: '是' },
            { id: 2, name: '否' },
          ],
          onChange: false,
        },
        is_commonly: {
          type: 'radio',
          title: '是否常用产品',
          hint: '请填写产品是否常用产品',
          options: [
            { id: 1, name: '是' },
            { id: 2, name: '否' },
          ],
          onChange: false,
        },
        effect_tagsList: {
          type: 'checkbox',
          title: '表面效果',
          hint: '请选择该产品的表面效果',
          options: [
            {
              id: '1',
              name: "光面"
            },
            {
              id: '2',
              name: "亚光"
            },
            {
              id: '3',
              name: "火烧"
            },
            {
              id: '4',
              name: "荔枝"
            },
            {
              id: '5',
              name: "剁斧"
            },
            {
              id: '6',
              name: "仿古"
            },
            {
              id: '7',
              name: "蘑菇"
            },
            {
              id: '8',
              name: "拉槽"
            },
          ],
          key: 'name',
          loading: false,
        },
        install_pivot: {
          type: 'textarea',
          title: '安装施工要点',
          hint: '请填写安装施工要点',
          length: 'long',
        },
        su_desc: {
          fileList: [],
          type: 'img',
          title: '上传SU材质贴图',
          hint: '支持上传jpg/png/gif格式，不超过10M，最多6张',
          limit: 6,
          allData: true
        },
        install_desc: {
          fileList: [],
          type: 'img',
          title: '上传做法详图',
          hint: '支持上传jpg/png/gif格式，不超过10M，最多6张',
          limit: 6,
          allData: true
        },
      },
      dividerConfig: [
        {
          text: '产品信息',
          relatedItem: 'name',
        },
        {
          text: '产品参数',
          relatedItem: 'place',
        },
      ],
      renderBts: [
        {
          label: '发布并保存',
          editLabel: '修改并发布',
          type: 'submit',
          onClick: this.onValidate,
          classes: 'fix-width',
        },
        {
          label: '草稿箱',
          editLabel: "修改并发布",
          onClick: this.onDrafts,
          classes: "fix-width",
        },
        {
          label: '取消',
          type: 'cancel',
          onClick: this.onCancel,
        },
      ],
    };
  },
  computed: mapState({
    molds: (state) => state.molds,
    cities: (state) => state.cities,
    isNew() {
      return this.id === undefined;
    },
  }),
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
    molds(val) {
      this.renderItems.mold_id.options = val;
    },
    cities(val) {
      this.renderItems.prov_id.options = val;
    },
  },
  created() {
    this.renderItems.mold_id.options = this.molds || [];
    this.renderItems.prov_id.options = this.cities || [];
  },
  methods: {
    async init() {
      if (!this.isNew) {
        this.editLoading = true;
        this.$store.commit('openLoading');
        const res = await this.getDetail();
        await this.getChildMolds(res.data.mold_id);
        this.handlerData(res.data);
        this.editLoading = false;
        this.$store.commit('closeLoading');
      } else {
        const localDrafts = localstorage.get('PROD_DRAFTS')
        this.fillDrafts(localDrafts)
      }
    },
    async fillDrafts(data) {

      if (data.content) {
        this.renderItems.content.data = data.content.toString()
      }

      if (data.mold_id) {
        await this.getChildMolds(data.mold_id);
      }
      Object.keys(data).forEach(key => {
        if (data[key]) {
          this.form[key] = data[key]
        }
      })

    },
    onValidate(extendParams, e) {
      const target = e.currentTarget;
      const { index } = target.dataset;
      this.loading = true;
      this.btCurrentIndex = index;
      this.$refs.postForm.onFormValidate();
    },
    onCancel() {
      this.$router.go(-1);
    },
    async onSubmit(val) {
      const that = this;
      const message = that.isNew
        ? '产品发布成功，小材宝会尽快为您审核，审核完成后将在首页显示！'
        : '产品编辑成功，小材宝会尽快为您审核，审核完成后将在首页显示！';
      const jumpTo = that.isNew ? '/search/product' : '/my/manage/products';

      val.effect_tags = val.effect_tagsList.join(',')
      delete this.renderItems.effect_tagsList
      delete val.effect_tagsList
      console.log(val, 989898)
      // return

      if (that.isNew) {
        await create(val);
      } else {
        const postData = val;
        postData.id = this.id;
        await edit(postData);
      }
      localstorage.remove("PROD_DRAFTS")
      that.$message({
        type: 'success',
        message,
        duration: 1000,
        onClose() {
          that.$router.push({
            path: jumpTo,
          });
        },
      });
      that.loading = false;
    },
    moldOnChange(id) {
      console.log(this.form, 999)
      this.getChildMolds(id);
    },
    async getChildMolds(id) {
      this.renderItems.mold_ids.loading = true;
      const res = await molds(id);
      const { list } = res.data;
      this.renderItems.mold_ids.options = list;
      this.renderItems.mold_ids.loading = false;
    },
    onFormValidateError(err) {
      console.log(err);
      this.loading = false;
    },
    getDetail() {
      return editDetail({
        id: this.id,
      });
    },
    handlerData(data) {
      const titlePictureUrlShow = parseImage(data.title_picture_url);
      const pictureIds = [];
      const pictureIdsShow = [];
      let su_descIdsShow = []
      let install_descIdsShow = []
      data.picture_ids.forEach((item) => {
        pictureIds.push(item.id);
        pictureIdsShow.push({
          name: item.url,
          url: parseImage(item.url),
          id: item.id,
        });
      });
      if (data.su_desc) {
        data.su_desc = JSON.parse(data.su_desc)
        data.su_desc.forEach((item) => {
          su_descIdsShow.push({
            name: item.url,
            url: parseImage(item.url),
            id: item.id,
          });
        });
      }
      if (data.install_desc) {
        data.install_desc = JSON.parse(data.install_desc)
        data.install_desc.forEach((item) => {
          install_descIdsShow.push({
            name: item.url,
            url: parseImage(item.url),
            id: item.id,
          });
        });
      }
      const form = {
        title_picture_id: [data.title_picture_id],
        picture_ids: pictureIds,
        name: data.name,
        mold_id: data.mold_id,
        mold_ids: data.mold_ids.map((item) => Number(item)),
        prov_id: data.prov_id,
        content: data.content,
        place: data.place,
        tags: data.tags,
        model: data.model,
        style: data.style,
        absorption: data.absorption,
        size: data.size,
        brand: data.brand,
        min_price: data.min_price,
        max_price: data.max_price,
        effect_tags: data.effect_tags,
        install_pivot: data.install_pivot,
        is_commonly: data.is_commonly,
        is_customized: data.is_customized,
        su_desc: [],
        install_desc: [],
        effect_tagsList: data.effect_tags.split('、'),
      };

      this.form = form;
      this.renderItems.title_picture_id.fileList = [{
        name: data.title_picture_url,
        url: titlePictureUrlShow,
      }];
      this.renderItems.picture_ids.fileList = pictureIdsShow;
      this.renderItems.su_desc.fileList = su_descIdsShow;
      this.renderItems.install_desc.fileList = install_descIdsShow;
      this.renderItems.content.data = data.content;
    },
    onDrafts() {
      const that = this
      const result = Object.keys(that.form).some(key => that.form[key] != '')
      if (result) {
        localstorage.set('PROD_DRAFTS', that.form)
        that.$message({
          type: "success",
          message: '暂存成功',
        });
      } else {
        that.$message({
          type: "error",
          message: '请填写内容',
        });
      }
    },
  },
};
</script>

<style></style>
